import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { IButtonSkinProps } from './IButtonSkinProps';

export function SecondaryButton (props: IButtonSkinProps): ReactElement {
    const {
        className = '',
        disabled = false,
        children,
    }: IButtonSkinProps = props;

    const buttonClassNames: string = classNames({
        'text-primary group-focus:bg-white group-focus:text-primary-variant': !disabled,
        'bg-white text-black-30 border-black-30 opacity-70': disabled,
    });

    return (
        <div
            className={
                'type-button rounded px-3 inline-block border-2 border-primary hover:text-white hover:bg-primary ' +
                `${className} ${buttonClassNames}`
            }
        >
            {children}
        </div>
    );
}
